export const MOKU_IMAGE_NONE = 'MOKU_IMAGE_NONE';
export const MOKU_IMAGE_URL = 'MOKU_IMAGE_URL';
export const MOKU_IMAGE_CUSTOM = 'MOKU_IMAGE_CUSTOM';
export const ADD_MOKU_REQUEST = 'ADD_MOKU_REQUEST';
export const MOKU = 'MOKU';
